!function(){if(window&&window.Shopify){const a={add:"SCE:add",update:"SCE:update",change:"SCE:change",clear:"SCE:clear",mutate:"SCE:mutate"},c=["/cart/add","/cart/update","/cart/change","/cart/clear","/cart/add.js","/cart/update.js","/cart/change.js","/cart/clear.js"];if(window.fetch&&"function"==typeof window.fetch){const d=window.fetch;window.fetch=function(){const t=d.apply(this,arguments);return e(arguments[0])&&t.then(e=>{e.clone().json().then(t=>n(e.url,t))}),t}}if(window.XMLHttpRequest){const i=window.XMLHttpRequest.prototype.open;window.XMLHttpRequest.prototype.open=function(){const t=arguments[1];return this.addEventListener("load",function(){e(t)&&n(t,this.response)}),i.apply(this,arguments)}}function e(t){if(t)return t=t.split("/").pop(),c.includes("/cart/"+t)}function n(t,e){if("string"==typeof e)try{e=JSON.parse(e)}catch{}window.dispatchEvent(new CustomEvent(a.mutate,{detail:e}));t=!!(t=t)&&(t.includes("cart/add")?"add":t.includes("cart/update")?"update":t.includes("cart/change")?"change":!!t.includes("cart/clear")&&"clear");switch(t){case"add":window.dispatchEvent(new CustomEvent(a.add,{detail:e}));break;case"update":window.dispatchEvent(new CustomEvent(a.update,{detail:e}));break;case"change":window.dispatchEvent(new CustomEvent(a.change,{detail:e}));break;case"clear":window.dispatchEvent(new CustomEvent(a.clear,{detail:e}))}}}}();

///////////////////////////////////////////////////* 
////// begin Poppy custom code for GiftShip cart
//////////////////////////////////////////////////*/

const poppyCountDownMin = 20;
const poppyOrderMin = 1;

document.addEventListener('giftship.drawer-cart.item-updated', function(event) {
  console.log("giftship.drawer-cart.item-updated");
  console.log(event);
  poppyCart(event.detail.cartData);
});

document.addEventListener('giftship.drawer-cart.opened', function(event) {
  console.log("giftship.drawer-cart.opened");
  console.log(event);
  poppyCart(event.detail.cartData);
});


// === Compare-at price under unit price in Giftship drawer (idempotent, cached) ===
(function () {
  var cache   = Object.create(null);   // variantId -> { price, compare_at_price }
  var pending = Object.create(null);   // variantId -> [callbacks] (prevents double-append races)

  // Money formatter (uses Shopify if available)
  function fmt(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var format =
          (window.theme && theme.moneyFormat) ||
          (window.shop && window.shop.money_format) ||
          (window.Shopify && window.Shopify.money_format) ||
          '${{amount}}';
        return Shopify.formatMoney(cents, format);
      }
    } catch (_) {}
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  // Ensure exactly one <s> inside baseWrap; never duplicates
  function renderInto(baseWrap, price, compare, variantId) {
    // If we already rendered for this exact variant id, bail
    if (baseWrap.dataset.compareFor === String(variantId)) return;

    // Clean any prior injected nodes (handles re-renders)
    baseWrap.querySelectorAll('.gs__drawer-compare').forEach(function (n) { n.remove(); });

    if (Number(compare) > Number(price)) {
      var s = document.createElement('s');
      s.className = 'gs__drawer-compare';
      s.textContent = fmt(compare);
      s.style.marginLeft = '8px';
      s.style.color = '#8a8a8a';
      s.style.fontWeight = '500';
      baseWrap.appendChild(s);
    }

    // Mark this wrapper as rendered for this variant id
    baseWrap.dataset.compareFor = String(variantId);
  }

  function renderRow(row) {
    var baseWrap  = row.querySelector('.gs__drawer-base-price-wrapper');
    var variantId = row.getAttribute('data-variant-id');
    if (!baseWrap || !variantId) return;

    // If we already have data, draw immediately (no duplicate risk)
    if (cache[variantId]) {
      var v = cache[variantId];
      return renderInto(baseWrap, v.price, v.compare_at_price, variantId);
    }

    // Avoid multiple concurrent fetches for the same variant
    if (pending[variantId]) {
      pending[variantId].push(function (v) {
        renderInto(baseWrap, v.price, v.compare_at_price, variantId);
      });
      return;
    }

    pending[variantId] = [
      function (v) { renderInto(baseWrap, v.price, v.compare_at_price, variantId); }
    ];

    fetch('/variants/' + variantId + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var v = data && data.variant ? data.variant : null;
        if (!v) { delete pending[variantId]; return; }

        var obj = {
          price: Number(v.price || 0),
          compare_at_price: Number(v.compare_at_price || 0)
        };
        cache[variantId] = obj;

        // Flush all waiters once (prevents double appends)
        pending[variantId].forEach(function (cb) { cb(obj); });
        delete pending[variantId];
      })
      .catch(function () { delete pending[variantId]; });
  }

  function renderAll() {
    var drawer = document.getElementById('gsDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('.gs__drawer-li').forEach(renderRow);
  }

  // Re-render on Giftship events (open + any item update)
  document.addEventListener('giftship.drawer-cart.opened', renderAll);
  document.addEventListener('giftship.drawer-cart.item-updated', renderAll);

  // If drawer already visible, try once now
  renderAll();
})();


// === Always show variant/options (e.g., "Size: 3 Bags") in the Giftship drawer ===
(function () {
  function injectVariant(infoEl, afterNode, text) {
    if (!text || /Default Title/i.test(text)) return;

    // remove any previously injected row to avoid duplicates
    var old = infoEl.querySelector('.poppy-variant-line');
    if (old) old.remove();

    var div = document.createElement('div');
    div.className = 'poppy-variant-line';
    div.style.fontSize = '12px';
    div.style.lineHeight = '1.3';
    div.style.color = '#6b6b6b';
    div.style.marginTop = '2px';
    div.textContent = text;
    afterNode.insertAdjacentElement('afterend', div);
  }

  function renderVariants() {
    var drawer = document.getElementById('gsDrawer');
    if (!drawer) return;

    drawer.querySelectorAll('.gs__drawer-li').forEach(function (row) {
      var info = row.querySelector('.gs__drawer-product-info');
      if (!info) return;

      // place our line right under the unit price (or under title if price wrapper is missing)
      var baseWrap =
        info.querySelector('.gs__drawer-base-price-wrapper') ||
        info.querySelector('.gs__drawer-product-title');
      if (!baseWrap) return;

      // 1) If Giftship already rendered the options, use that text
      var gsOptions = info.querySelector('.gs__drawer-variant-options');
      if (gsOptions && gsOptions.textContent.trim()) {
        var txt = gsOptions.textContent.trim().replace(/\s+/g, ' ');
        injectVariant(info, baseWrap, txt);
        return;
      }

      // 2) Otherwise fetch the variant title and show it (fast & reliable)
      var variantId = row.getAttribute('data-variant-id');
      if (!variantId) return;

      fetch('/variants/' + variantId + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var title = (data && data.variant && data.variant.title) ? data.variant.title.trim() : '';
          if (!title) return;

          // Example: "3 Bags" or "Red / Large" — show verbatim
          injectVariant(info, baseWrap, title);
        })
        .catch(function () { /* silent */ });
    });
  }

  // === Remove quantity selector for FREE GIFT product  17 March 26 Ray===

  // === Remove quantity selector for FREE GIFT product ===
// Hide quantity selector for FREE GIFT

// === Remove quantity selector for FREE GIFT ===
  
// === Remove quantity selector for FREE GIFT product ===
(function(){

  const FREE_GIFT_PRODUCT_ID = "9190027100396";

  function hideFreeGiftQty(){

    const drawer = document.getElementById('gsDrawer');
    if(!drawer) return;

    const freeGiftRow = drawer.querySelector(
      '.gs__drawer-li[data-product-id="'+FREE_GIFT_PRODUCT_ID+'"]'
    );

    if(!freeGiftRow) return;

    const qtyBlock = freeGiftRow.querySelector('.gs__drawer-li-updates');

    if(qtyBlock){
      qtyBlock.style.display = "none";
    }

  }

  document.addEventListener('giftship.drawer-cart.opened', hideFreeGiftQty);
  document.addEventListener('giftship.drawer-cart.item-updated', hideFreeGiftQty);

  hideFreeGiftQty();

})();


  /*
(function () {

  function hideFreeGiftQty() {
    var drawer = document.getElementById('gsDrawer');
    if (!drawer) return;

    drawer.querySelectorAll('.gs__drawer-li').forEach(function(row){

      var title = row.querySelector('.gs__drawer-product-title');
      if(!title) return;

      if(title.textContent.includes('FREE GIFT: Asheville Mix Snack Bag Set')){

        var qty = row.querySelector('.gs__drawer-qty-wrapper');
        if(qty){
          qty.style.display = 'none';
        }

      }

    });
  }


    document.addEventListener('giftship.drawer-cart.opened', hideFreeGiftQty);
    document.addEventListener('giftship.drawer-cart.item-updated', hideFreeGiftQty);

    hideFreeGiftQty();

  })();
*/


  // Run when drawer opens or items change
  document.addEventListener('giftship.drawer-cart.opened', renderVariants);
  document.addEventListener('giftship.drawer-cart.item-updated', renderVariants);

  // If drawer is already present, try once
  renderVariants();
})();

/*
const boxBuilderRoot = document.getElementById('boxBuilderRoot')
const boxButtonObserver = new MutationObserver(function(mutations) {
  if (document.contains(boxBuilderRoot)) {
    if (boxBuilderRoot.querySelector('.gs__btn.gs__btn-primary.gs__btn-add-cart')) {
      const boxAddToCart = boxBuilderRoot.querySelector('.gs__btn.gs__btn-primary.gs__btn-add-cart');
      if (!boxAddToCart.disabled) {
        boxAddToCart.addEventListener('click', function(event) {
          window.setTimeout(function () {
            window.location.href= '/?gs_drawer_open=true';
          },500);
        });
        observer.disconnect();
      }
    }
  }
});

boxButtonObserver.observe(document, {attributes: true, childList: true, characterData: false, subtree:true});
*/

document.addEventListener('giftship.drawer-cart.init', function(event) {
  console.log("giftship.drawer-cart.init");
  const cartItem = document.querySelector('.site-header__cart');
  cartItem.classList.add('ready');
});

window.setTimeout(function () {
  const cartItem = document.querySelector('.site-header__cart');
  //adding cart ready
  if (cartItem.classList.contains('ready')) return;
  cartItem.classList.add('ready');
},3000);

window.addEventListener('SCE:mutate', (event) => {
  //console.log('SCE:mutate');
  //console.log(event.detail);
  const cartJson = '/cart.js';
  fetch(cartJson).then((res) => {
    return res.json();
  })
  .then((data) => {
    const existingCount = parseInt(document.querySelector('span[data-cart-count]').textContent);
    const newCount = parseInt(data.item_count);
    document.querySelector('span[data-cart-count]').textContent = data.item_count;
    const gsDrawer = document.getElementById('gsDrawer')
    //console.log(gsDrawer)
    if (gsDrawer && gsDrawer.classList.contains('gs__active')) {
      
    }
    else {
      if ((newCount != existingCount) && window.location.href.indexOf('a/gs/builder/')>-1) {
        //console.log('redirect to index with cart open')
        window.location.href= '/?gs_drawer_open=true';
      }
    }
  })
  .catch((error) => {
    console.log(error);
  });
});

window.poppyCart = window.poppyCart || {};

const poppyCart = function (cartData) {
  if (window.poppyCart.rendered === true) return;

  localStorage.removeItem('gsBuilderItems_1586');
  localStorage.removeItem('gsBuilderItems_1587');
  
  const cartDrawer = document.getElementById('gsDrawer');


  
  const gsAnnouncementBars = cartDrawer.querySelectorAll('.gs__announcement-bar-slide');
  gsAnnouncementBars.forEach(function (element) {
    window.setTimeout(function () {
      element.setAttribute('data-original-message', element.innerHTML);
    },100);
  });




  // Show compare-at next to the unit price (idempotent)
  // poppyRenderDrawerCompareAt();



// --- Compare-at under unit price in Giftship drawer ---
(function addCompareAtToDrawer() {
  var drawer = document.getElementById('gsDrawer');
  if (!drawer) return;

  // Safe money formatter (no Liquid)
  function fmt(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format = (window.theme && theme.moneyFormat) ? theme.moneyFormat : '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }
    // fallback
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  // For each line item in the drawer, fetch its variant to get compare_at_price
  var rows = drawer.querySelectorAll('.gs__drawer-li');
  rows.forEach(function(row) {
    // skip if we already injected a compare-at next to base price
    if (row.querySelector('.gs__drawer-compare')) return;

    var unitPriceEl = row.querySelector('.gs__drawer-base-price');
    var handle      = row.getAttribute('data-product-handle');
    var vid         = row.getAttribute('data-variant-id');

    if (!unitPriceEl || !handle || !vid) return;

    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.json(); })
      .then(function(prod){
        if (!prod || !prod.variants) return;
        var v = prod.variants.find(function(x){ return String(x.id) === String(vid); });
        if (!v) return;

        // product.js returns cents for price/compare_at_price
        var unit  = Number(v.price || 0);
        var comp  = Number(v.compare_at_price || 0);

        if (comp && comp > unit) {
          var s = document.createElement('span');
          s.className = 'gs__drawer-compare';
          s.style.marginLeft = '8px';
          s.style.color = '#8a8a8a';
          s.style.fontWeight = '500';
          s.innerHTML = '<s>' + fmt(comp) + '</s>';
          unitPriceEl.after(s);
        }
      })
      .catch(function(){ /* ignore */ });
  });
})();


  let canCheckout = true; //poppyCanCheckout(cartData);





  
  if (canCheckout) {
    window.poppyCart.canCheckout = true;
    poppyRenderCountdownTimer()
  }
  else {
    window.poppyCart.canCheckout = false;
    poppyRenderCartMin(cartData)
  }

}



const poppyCanCheckout = function (cartData) {
  let validTypes = ['Gift Set', 'Gift Box','Pack','Bundle','GIST_BUILDER_PRODUCT'];
  let hasBoxOrSet = false;
  cartData.items.forEach(function (item) {
    if (validTypes.indexOf(item.product_type) > -1) {
      hasBoxOrSet = true;
    }
  });

  if (hasBoxOrSet) {
    return true;
  }

  let totalItemCount = poppyCountCartItems(cartData);
  if (totalItemCount < poppyOrderMin) {
    return false;
  }
  return true;
}

const poppyCountCartItems = function (cartData) {
  let totalItemCount = 0;
  cartData.items.forEach(function (item) {
    if (item.properties && item.properties.hasOwnProperty('_gs_bundle_quantities')) {
      let thisItemCount = 0;
      const bundleQuantities = item.properties._gs_bundle_quantities;
      for (const key in bundleQuantities) {
        thisItemCount += parseInt(bundleQuantities[key]);
      }
      totalItemCount += (thisItemCount * item.quantity);
    }
    else {
      totalItemCount += item.quantity;
    }
  });
  return totalItemCount;
}

const poppyRenderCountdownTimer = function () {
  const cartDrawer = document.getElementById('gsDrawer');
  const gsAnnouncementBars = cartDrawer.querySelectorAll('.gs__announcement-bar-slide');
  gsAnnouncementBars.forEach(function (element) {
    window.setTimeout(function () {
      if (element.innerHTML.indexOf('products are reserved')>-1) {
        element.innerHTML = element.innerHTML.replace('[countdown timer]', '<div id="poppyCountdownTimer">'+poppyCountDownMin+':00</div>');
        element.parentNode.parentNode.classList.add('shown');
        const buttons = cartDrawer.querySelectorAll('.gs__drawer-footer-btns button');
        buttons.forEach(function (element) {
          element.disabled = false;
          if (element.classList.contains('disabled')) {
            element.classList.remove('disabled');
          }
          if (element.classList.contains('gs__drawer-checkout-btn')) {
            element.innerHTML = `Checkout`;
          }
        });
        poppyCountdownTimer('poppyCountdownTimer');
      }
      else {
        element.parentNode.parentNode.classList.remove('shown');
      }
    },300);
  });
}

const poppyCountdownTimer =  function (elementId) {
  let duration = poppyCountDownMin * 60;
  const element = document.getElementById(elementId);

  if (duration <= 0) {
    element.style.display = 'none';
    return;
  }
  const interval = setInterval(() => {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;

    element.textContent = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

    if (duration <= 0) {
      element.style.display = 'none';
      return;
      clearInterval(interval);
    } else {
      duration--;
    }
  }, 1000);

}

const poppyRenderCartMin = function (cartData) {
  console.log("poppyRenderCartMin");
  const cartDrawer = document.getElementById('gsDrawer');
  const gsAnnouncementBars = cartDrawer.querySelectorAll('.gs__announcement-bar-slide');
  const itemCount = poppyCountCartItems(cartData);
  const buttons = cartDrawer.querySelectorAll('.gs__drawer-footer-btns button');
  const orderDiff = poppyOrderMin - itemCount;
  const plural = orderDiff > 1 ? 's' : '';
  buttons.forEach(function (element) {
    element.disabled = true;
    if (!element.classList.contains('disabled')) {
      element.classList.add('disabled');
    }
    if (element.classList.contains('gs__drawer-checkout-btn')) {
      element.innerHTML = `Add ${orderDiff} bag${plural} to ship`;
    }
  });
  gsAnnouncementBars.forEach(function (element) {
    window.setTimeout(function () {
      if (element.innerHTML.indexOf('Minimum order')>-1) {
        element.innerHTML = `<div id="poppyCartMin"><p>Add ${orderDiff} more bag${plural} to checkout</p>Minimum order of ${poppyOrderMin} bags to ship.</div>`;
        element.parentNode.parentNode.classList.add('shown');
      }
      else {
        element.parentNode.parentNode.classList.remove('shown');
      }
    },300);
  });
}

/*
document.addEventListener("DOMContentLoaded", (event) => {
  let cartIcon = document.querySelector(".site-header__cart");
  cartIcon.addEventListener("click", function (event) {
    console.log("cart icon clicked");
    var triggerEvent = new CustomEvent('giftship.drawer-cart.trigger');
    console.log(triggerEvent);
    document.dispatchEvent(triggerEvent);
    //event.preventDefault();
  });
});
*/

////////////////////////////////////* 
////// begin existing Poppy custom 
///////////////////////////////////*/

$(".search-form__clear-action").click(function () {
  window.location.href = "search";
});

// funhction to handle add to cart button
function add_to_cart(element) {
  let variants = JSON.parse(element.dataset.variants);
  var variantInStock = variants.find(function (variant) {
    return variant.available;
  });
  if (variantInStock) {
    $(
      ".product-recommended-add-button.product-recommended-added-to-cart-button"
    ).prop("disabled", true);
    var variantId = variantInStock.id;
    var quantity = 1;

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: variantId,
        quantity: quantity,
      },
      success: function () {},
      error: function () {
        // alert("Error adding product to cart");
      },
      complete: function () {
        $(
          ".product-recommended-add-button.product-recommended-added-to-cart-button"
        ).prop("disabled", false);
      },
    });
  }
}

// select variant of the product by button on producttemplate
$(".poppy__button").click(function (e) {
  let ele = $(this);
  var variantid = ele.data("variant-id");
  var imageUrl = ele.data("src");
  var variant = ele.data("variant");
  // if ($('input[name="id"]').attr('data-productid') != '8084026261740') {
    $("[data-regular-price]").html(
      theme.Currency.formatMoney(variant.price, theme.moneyFormat)
    );
  // }
  $(".thumbnail").each(function (index, item) {
    var thumn = $(this);
    if (thumn.attr("data-src") === imageUrl) {
      splideCarouselSlider.go(index);
    }
  });
  document.querySelector("#selected_variant_id").value = variantid;
  $(".poppy__button").removeClass("active");
  ele.addClass("active");
});

// image zoomin code

$(".imagezoom").each(function (index, item) {
  item.addEventListener("mousemove", (e) => {
    const { left, top, width, height } = item.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    item.style.transformOrigin = `${x}% ${y}%`;
  });

  item.addEventListener("mouseenter", () => {
    item.classList.add("zoomed");
  });

  item.addEventListener("mouseleave", () => {
    item.classList.remove("zoomed");
  });
});

$("#ingredient-icon").click(function () {
  let eleme = $(this);
  if (eleme.hasClass("fa-plus")) {
    eleme.removeClass("fa-plus");
    eleme.addClass("fa-minus");
  } else {
    eleme.addClass("fa-plus");
  }
  $("#ingredient-content").slideToggle();
});
$("#allergyInformation-icon").click(function () {
  let eleme = $(this);
  if (eleme.hasClass("fa-plus")) {
    eleme.removeClass("fa-plus");
    eleme.addClass("fa-minus");
  } else {
    eleme.addClass("fa-plus");
  }
  $("#allergyInformation-content").slideToggle();
});
$("#list_of_potential_flavors").click(function () {
  let eleme = $(this);
  if (eleme.hasClass("fa-plus")) {
    eleme.removeClass("fa-plus");
    eleme.addClass("fa-minus");
  } else {
    eleme.addClass("fa-plus");
  }
  $("#list_of_potential_flavors-content").slideToggle();
});

// product page slider code
if ($("#product-media-slider").length > 0) {
  var splideCarouselSlider = new Splide("#product-media-slider", {
    pagination: true,
  });
  var thumbnails = document.querySelectorAll(".thumbnail");
  var current;

  for (var i = 0; i < thumbnails.length; i++) {
    initThumbnail(thumbnails[i], i);
  }

  function initThumbnail(thumbnail, index) {
    thumbnail.addEventListener("click", function () {
      splideCarouselSlider.go(index);
    });
  }

  splideCarouselSlider.on("mounted move", function () {
    var activeIndex = splideCarouselSlider.index;

    var totalNumberOfThumbnails = thumbnails.length;
    thumbnails.forEach(function (thumbnail, index) {
      if (index >= activeIndex && index < activeIndex + 3) {
        thumbnail.style.display = "block";
      } else {
        thumbnail.style.display = "none";
      }
    });

    if (activeIndex >= totalNumberOfThumbnails - 3) {
      for (
        var i = totalNumberOfThumbnails - 3;
        i < totalNumberOfThumbnails;
        i++
      ) {
        if (thumbnails[i % totalNumberOfThumbnails] !== undefined) thumbnails[i % totalNumberOfThumbnails].style.display = "block";
      }
    }
  });
  splideCarouselSlider.mount();
}








